module.exports = __webpack_public_path__ + "img/lbl-01.8f2dc4e8.png";